import { Suspense, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Navbar from '@/core/layouts/main-layout/components/navbar/Navbar';
import Sidebar from '@/core/layouts/main-layout/components/sidebar/Sidebar';
import Footer from '@/core/layouts/main-layout/components/footer/Footer';
import { Spinner } from '@/core/shared/components/loader/Loader';

export const MainLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
      // Don't auto-close sidebar on mobile - let user control it
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);
    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleOverlayClick = () => {
    if (isMobile && sidebarOpen) {
      setSidebarOpen(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen bg-background text-text-primary transition-colors duration-300" data-testid="main-layout">
      <div className="flex-shrink-0 w-full" data-testid="navbar-container">
        <Navbar />
      </div>
      
      {/* Mobile overlay */}
      {isMobile && sidebarOpen && (
        <div 
          className="fixed inset-0 bg-opacity-50 z-30 md:hidden"
          onClick={handleOverlayClick}
          data-testid="mobile-overlay"
        />
      )}
      
      <div 
        className="flex flex-1 w-full relative mt-[6.1875rem] mb-[3.75rem] min-h-[calc(100vh-9.9375rem)]"
        data-testid="content-area"
      >
        {/* Sidebar - let it handle its own positioning */}
        <Sidebar isOpen={sidebarOpen} onToggleSidebar={toggleSidebar} />
        
        {/* Main content with dynamic margin for desktop sidebar */}
        <main 
          className={`
            flex flex-1 min-w-0 transition-all duration-300 relative ml-0
            ${!isMobile && sidebarOpen ? '' : ''}
          `}
          data-testid="main-content"
        >
          <div 
            className="flex flex-col flex-1 w-full h-full gap-3 md:gap-4 lg:gap-5"
            data-testid="content-container"
          >
            <Suspense 
              fallback={
                <div 
                  className="flex items-center justify-center h-32 sm:h-40 md:h-48 lg:h-56"
                  data-testid="loading-container"
                >
                  <div className="flex flex-col items-center justify-center gap-2 sm:gap-3 md:gap-4">
                    <Spinner 
                      data-testid="loading-spinner"
                      aria-label="Loading content"
                    />
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              }
            >
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
      
      <Footer />
    </div>
  );
};

export default MainLayout;